import React, { useEffect, useRef } from "react";
import { useMutation } from "react-query";
import { useNavigate, useSearchParams } from "react-router-dom";
import { getPostJumpInToken } from "../Helpers/backendHelper";
import { userLogin } from "../Helpers/utils";
import { LoadingScreen } from "../Components/utils/loadingScreen";

export const PostLoginRegister: React.FC = () => {
  const [searchParams] = useSearchParams();
  const code = searchParams.get("code");
  const navigate = useNavigate();
  const hasAuthenticated = useRef<boolean>(false);

  const registerMutation = useMutation({
    mutationFn: (authCode: string) => getPostJumpInToken("google", authCode),
    onSuccess: (data: any) => {
      userLogin(data);
      hasAuthenticated.current = true;
      navigate("/");
    },
    onError: (error: unknown) => {
      console.error(error);
      navigate("/jumpin");
    },
  });

  useEffect(() => {
    if (code && !hasAuthenticated.current) {
      registerMutation.mutate(code);
      hasAuthenticated.current = true;
    }
  }, [code, registerMutation]);

  return <LoadingScreen />;
};